import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';

//SERVICES
import { ConfigService } from '../services/config.service';
//MODELS
import { Destination } from '../models/destination.interface';
import { Observable, of, Subscriber } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { CompassApiGetResults } from '../models/compass-api-get-results.interface';


@Injectable({providedIn: SharedModule})
export class CompassAPIDestinationsService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService
	) {

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'destinations';

	}


	/**
	 * Get Destinations
	 * @param search
	 * @param limit
	 * @param offset 
	 * @param regionId 
	 * @returns
	*/
	public getDestinations (search: string = null, limit: number = null, offset: number = null, regionId: string = null){
		let url = new URL(this.baseUrl);
		if(search) url.searchParams.append('SearchTerm', search);
		if(limit) url.searchParams.append('limit', String(limit));// Todo: Call .toString()
		if(offset) url.searchParams.append('offset', String(offset));
		if(regionId) url.searchParams.append('regionId', String(regionId));
		//console.log('API.getDestinations().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
			//	console.log('API.getDestinations.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const destinations: Destination[] = res.results.map(this.proccessDestinationRegion);
					return destinations;
				} else {
					return null;
				}
			}));
	}



	/**
	 * Get Destinations By Region List
	 * @param search
	 * @param limit
	 * @param offset 
	 * @param regionId 
	 * @returns
	*/
	public getDestinationsByRegionList (search: string = null, limit: number = null, offset: number = null, regionId: string = null){
		let url = new URL(this.baseUrl + '/regiondestinationslist');
		if(search) url.searchParams.append('SearchTerm', search);
		if(limit) url.searchParams.append('limit', String(limit));// Todo: Call .toString()
		if(offset) url.searchParams.append('offset', String(offset));
		if(regionId) url.searchParams.append('regionId', String(regionId));
		//console.log('API.getDestinationsByRegionList().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getDestinationsByRegionList.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const results: Destination[] = res.results.map(this.proccessDestinationRegion);
					// const getResults: CompassApiGetResults = {
					// 	total: res.total,
					// 	results: results
					// }
					// return getResults;
					return results;
				} else {
					return null;
				}
			}));
	}




	/**
	 * Get Destination by ID or Slug
	 * @param idOrSlug
	 * @returns
	 */
	 public getDestinationByIdOrSlug (idOrSlug: string): Observable<Destination>{
		let url = this.baseUrl + '/' + idOrSlug;
		//console.log('API.getDestinationByIdOrSlug().url:', url);

		return this.httpClient
			.get(url, { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getDestinationByIdOrSlug.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const destination: Destination = this.proccessDestinationRegion(res.result);
					return destination;
				} else {
					return null;
				}
			}));
	}



	/**
	 * Post (create) Destinations
	 * @param data:Destination
	 * @returns
	*/
	public postDestinations (data:Destination){
		let url = this.baseUrl,
			body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.postDestinations().url', url);
		// console.log('API.postDestinations().body', body);
		// console.log('API.postDestinations().options', options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postDestinations.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return this.proccessDestinationRegion(res.result);
				} else {
					return res;//uses error
				}
			}));
	}


	/**
	 * Put (update) Destinations
	 * @param id
	 * @param data:Destination
	 * @returns
	 */
	public putDestinations (id: string, data:Destination){
		let url = this.baseUrl + '/' + id,
			body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.putDestinations().url:', url);
		// console.log('API.putDestinations().body', body);
		// console.log('API.putDestinations().options', options);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putDestinations.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return this.proccessDestinationRegion(res.result);
				} else {
					return res;//uses error
				}
			}));
	}


	/**
	 * Delete Destination
	 * @param id
	 * @returns
	 */
	 public deleteDestinations (id: string){
		let url = this.baseUrl + '/' + id,
		options = {
			headers: this.config.headers,
		};
		//console.log('API.deleteDestinations().url', url);
		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteDestinations.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;
				}
			}));
	}










	/**
	 * Post (create) Destinations assets
	 * @param slug
	 * @param data:form data
	 * @returns
	 */
	 public postDestinationsAssets (slug:string, data:any){
		let url = this.config.baseUrl + 'destinations/' + slug + '/assets',
			body = data,
			options = {
				headers: this.config.headersMulti,
			};
		// console.log('API.postDestinationsAssets().url', url);
		// console.log('API.postDestinationsAssets().body', body);
		// console.log('API.postDestinationsAssets().options', options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postDestinationsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.results;
				} else {
					return res;//uses error
				}
			}));
	}


	/**
	 * Delete Destinations assets
	 * @param slug
	 * @param name - name includes slashes and needs to be escaped
	 * @returns
	 */
	 public deleteDestinationsAssets (slug:string, name:string){
		let url = this.config.baseUrl + 'destinations/' + slug + '/assets/' + encodeURIComponent(name),
			//body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.deleteDestinationsAssets().url', url);
		//console.log('API.deleteDestinationsAssets().options', options);

		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteDestinationsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}



	private proccessDestinationRegion(destination: any) {
		if (destination.region && destination.region.id !== destination.regionId) {
			destination.regionId = destination.region.id;
		}

		return destination;
	}


}
